import { render, staticRenderFns } from "./HeadSetIcon.vue?vue&type=template&id=15dbdbb0"
import script from "./HeadSetIcon.vue?vue&type=script&lang=ts"
export * from "./HeadSetIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports